import type { TagTemplate, ViewportTitleDrawingTemplate } from "building-types/views/planSets";

export const SystemViewportTitleDrawingTemplate: ViewportTitleDrawingTemplate = {
  drawingType: "VIEWPORT_TITLE",
  templateType: "DRAWING",
  id: "defaultViewportTitleDrawingTemplate",
  labels: {},
  entityType: "CONTENT_TEMPLATE",
  name: "Default Viewport Title",
  sortIndex: 0,
};

export const SystemRoomTagTemplate: TagTemplate = {
  drawingType: "TAG",
  templateType: "DRAWING",
  id: "defaultRoomTagTemplate",
  labels: {},
  entityType: "CONTENT_TEMPLATE",
  name: "Room Tag (Default)",
  sortIndex: 0,
  targetEntityType: "ROOM",
};

export const SystemCeilingHeightRoomTagTemplate: TagTemplate = {
  drawingType: "TAG",
  templateType: "DRAWING",
  id: "ceilingHeightRoomTagTemplate",
  labels: {},
  entityType: "CONTENT_TEMPLATE",
  name: "Room Tag with Ceiling Height",
  sortIndex: 1,
  targetEntityType: "ROOM",
};

export const SystemFloorMaterialRoomTagTemplate: TagTemplate = {
  drawingType: "TAG",
  templateType: "DRAWING",
  id: "floorMaterialRoomTagTemplate",
  labels: {},
  entityType: "CONTENT_TEMPLATE",
  name: "Room Tag with Floor Material",
  sortIndex: 2,
  targetEntityType: "ROOM",
};

export const SystemDimensionsRoomTagTemplate: TagTemplate = {
  drawingType: "TAG",
  templateType: "DRAWING",
  id: "dimensionsRoomTagTemplate",
  labels: {},
  entityType: "CONTENT_TEMPLATE",
  name: "Room Tag with Dimensions",
  sortIndex: 3,
  targetEntityType: "ROOM",
};

export const SystemAreaRoomTagTemplate: TagTemplate = {
  drawingType: "TAG",
  templateType: "DRAWING",
  id: "areaRoomTagTemplate",
  labels: {},
  entityType: "CONTENT_TEMPLATE",
  name: "Room Tag with Area",
  sortIndex: 4,
  targetEntityType: "ROOM",
};

export const SystemDrawingTemplates = {
  [SystemViewportTitleDrawingTemplate.id]: SystemViewportTitleDrawingTemplate,
  [SystemRoomTagTemplate.id]: SystemRoomTagTemplate,
  [SystemCeilingHeightRoomTagTemplate.id]: SystemCeilingHeightRoomTagTemplate,
  [SystemFloorMaterialRoomTagTemplate.id]: SystemFloorMaterialRoomTagTemplate,
  [SystemDimensionsRoomTagTemplate.id]: SystemDimensionsRoomTagTemplate,
  [SystemAreaRoomTagTemplate.id]: SystemAreaRoomTagTemplate,
};
